import useContract from './useContract';
import StakingPool from '../contracts/HookableStakingPool.json';

const useCompanionStakingPool = () =>
  useContract(
    process.env.NEXT_PUBLIC_COMPANION_STAKING_POOL_CONTRACT_ADDRESS,
    StakingPool.abi
  );

export default useCompanionStakingPool;
